/* eslint fp/no-mutation: 0 */
import { fabric } from "fabric";

fabric.Group.prototype.lockUniScaling = true;
fabric.Group.prototype.hasControls = true;
fabric.Group.prototype.hasRotatingPoint = true;

fabric.ActiveSelection.prototype.hasControls = true;
